<template>
  <v-card
    :loading="loading"
    class="pa-0"
  >
    <v-card-text class="pa-0">
      <v-data-table
        :items="pagesToShow"
        :headers="headers"
        class="row-pointer"
        :items-per-page="-1"
        @click:row="rowClick"
      >
        <template #[`item.url`]="{ item }">
          <a
            :href="item.fullUrl"
            target="_blank"
            class="info--text"
          >
            {{ item.url }}
          </a>
        </template>
        <template #[`item.description`]="{ item }">
          <v-icon
            v-if="!!item.description"
            color="success"
          >
            mdi-check
          </v-icon>
        </template>
        <template #[`item.longContent`]="{ item }">
          <v-icon
            v-if="!!item.longContent"
            color="success"
          >
            mdi-check
          </v-icon>
        </template>
        <template #[`item.blogPosts`]="{ item }">
          {{ item.blogPosts }}
        </template>
        <template #[`item.questions`]="{ item }">
          {{ (item.questions || []).length }}
        </template>
        <template #[`item.actions`]="{}">
          <v-icon>more_vert</v-icon>
        </template>
      </v-data-table>
    </v-card-text>
    <EditPage @reload="loadData" />
    <ContentCatalogFilter />
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import EditPage from '@/components/content/catalog/EditPage';
import ContentCatalogFilter from '@/components/content/catalog/Filter';
import { sortBy } from 'lodash';
export default {
  name: 'ContentCatalogList',
  components: { EditPage, ContentCatalogFilter },
  data() {
    return {
      loading: false,
      saving: false
    };
  },

  computed: {
    headers() {
      const list = [
        { text: 'Page', value: 'url' },
        { text: 'Score', value: 'score' },
        { text: 'Templates', value: 'templates' },
        { text: 'Desc', value: 'description' },
        { text: 'Long', value: 'longContent' },
        { text: 'Blog', value: 'blogPosts' },
        { text: 'FAQ', value: 'questions' },
        { text: '', value: 'actions', sortable: false }
      ];
      return list.filter((x) => !x.hide);
    },
    pagesToShow() {
      let list = this.pages;
      if (this.filter) {
        if (this.filter.search) {
          const search = this.filter.search.toLowerCase();
          list = list.filter(
            (x) => x.url.toLowerCase().includes(search) || x.pageName.toLowerCase().includes(search)
          );
        }
        if (this.filter.categoryId) {
          list = list.filter((x) => x.category && x.category.id === this.filter.categoryId);
        }
        if (this.filter.industryId) {
          list = list.filter((x) => x.industry && x.industry.id === this.filter.industryId);
        }
        if (this.filter.topicId) {
          list = list.filter((x) => x.topic && x.topic.id === this.filter.topicId);
        }
        if (this.filter.designGroupId) {
          list = list.filter((x) => x.designGroup && x.designGroup.id === this.filter.designGroupId);
        }
        if (this.filter.hasDescription === false) {
          list = list.filter((x) => !x.description);
        } else if (this.filter.hasDescription) {
          list = list.filter((x) => x.description);
        }
        if (this.filter.hasLongContent === false) {
          list = list.filter((x) => !x.longContent);
        } else if (this.filter.hasLongContent) {
          list = list.filter((x) => x.longContent);
        }
        if (this.filter.hasQuestions === false) {
          list = list.filter((x) => !(x.questions || []).length);
        } else if (this.filter.hasQuestions) {
          list = list.filter((x) => (x.questions || []).length);
        }
      }
      return sortBy(list, 'url');
    },
    ...mapGetters({
      pages: 'catalogPages/catalog_pages',
      filter: 'catalogPages/filter'
    })
  },

  async mounted() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.loading = true;

      Promise.all([
        this.$store.dispatch('lookup/getCategories'),
        this.$store.dispatch('lookup/getIndustries'),
        this.$store.dispatch('lookup/getTopics'),
        this.$store.dispatch('lookup/getDesignGroups'),
        this.$store.dispatch('catalogPages/setFilter', {}),
        this.$store.dispatch('catalogPages/getCatalogPages')
      ])
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rowClick(item) {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.EDIT_CATALOG_PAGE_SHOW, {
        id: item.id
      });
    }
  }
};
</script>
